import { useMutation } from '@tanstack/react-query';
import { aiApi, AIAlert } from '@/api/ai-api';

export interface AlertsCheckInput {
  patientId: string;
  medicalRecordId?: string;
  conversationId?: string;
  proposedMedications: string[];
  patientAllergies?: string[];
  patientChronicDiseases?: string[];
  currentMedications?: string[];
  pregnancy?: boolean;
  age?: number;
}

export function useAIAlertsCheck() {
  return useMutation<AIAlert[], Error, AlertsCheckInput>({
    mutationFn: async (payload: AlertsCheckInput) => aiApi.checkAlerts(payload),
  });
}